module.exports = __webpack_public_path__ + "img/Belarus.54f7e3da.svg";